import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { lazyLoadWithDimensions } from '../../../../util/uiHelpersOld.js';

import { AspectRatioWrapper } from '../../../../components/index.js';

import css from './YoutubeEmbed.module.css';

const RADIX = 10;
const BLACK_BG = '#000000';

//LazyIFrame is currently replaced by just 'iframe' due to render issues
const IFrame = props => <iframe {...props} />;
const LazyIFrame = lazyLoadWithDimensions(IFrame);

export const YoutubeEmbed = props => {
  const { className, rootClassName, youtubeVideoId, aspectRatio } = props;
  const [embedUrl, setEmbedUrl] = useState('');

  const hasSlash = aspectRatio.indexOf('/') > 0;
  const [aspectWidth, aspectHeight] = hasSlash ? aspectRatio.split('/') : [16, 9];
  const width = Number.parseInt(aspectWidth, RADIX);
  const height = Number.parseInt(aspectHeight, RADIX);
  const classes = classNames(rootClassName || css.video, className);

  // Build embed URL with origin parameter to fix Error 153
  useEffect(() => {
    if (typeof window !== 'undefined' && youtubeVideoId) {
      const origin = window.location.origin;
      const baseUrl = `https://www.youtube-nocookie.com/embed/${youtubeVideoId}`;
      const params = new URLSearchParams({
        origin: origin,
        enablejsapi: '1',
        rel: '0',
        modestbranding: '1',
      });
      setEmbedUrl(`${baseUrl}?${params.toString()}`);
    } else if (youtubeVideoId) {
      // Fallback for SSR - will be updated on client side
      setEmbedUrl(`https://www.youtube-nocookie.com/embed/${youtubeVideoId}`);
    }
  }, [youtubeVideoId]);

  return (
    <AspectRatioWrapper className={classes} width={width} height={height}>
      <iframe
        src={embedUrl || `https://www.youtube-nocookie.com/embed/${youtubeVideoId}`}
        className={css.iframe}
        style={{ background: BLACK_BG }}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
        title="Embedded youtube"
      />
    </AspectRatioWrapper>
  );
};

YoutubeEmbed.displayName = 'YoutubeEmbed';

YoutubeEmbed.defaultProps = {
  rootClassName: null,
  className: null,
  aspectRatio: '16/9',
};

YoutubeEmbed.propTypes = {
  rootClassName: string,
  className: string,
  youtubeVideoId: string.isRequired,
  aspectRatio: string,
};
